export const formatIban = (iban: string) => {
    return `* ${iban.replace(/\s/g, '').slice(-6, -2)} ${iban.slice(-2)}`;
};
